import { Helmet } from 'react-helmet'

import { useActiveStoreView } from '@emico/storeviews'

/**
 * Shows the Cookiebot consent banner.
 * We prefer manual mode, so the script is not blocking other stuff.
 * @see https://support.cookiebot.com/hc/en-us/articles/360009074960-Automatic-cookie-blocking
 */
export const CookieConsent = () => {
    const activeStoreView = useActiveStoreView()

    return (
        <Helmet>
            <script
                id="Cookiebot"
                src="https://consent.cookiebot.com/uc.js"
                data-cbid={process.env.REACT_APP_COOKIEBOT_CBID}
                data-culture={activeStoreView.language}
                async
                type="text/javascript"
            ></script>
        </Helmet>
    )
}
